import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { NamedLink, Button } from '../../components';
import option3 from './option3.png';
import css from './SectionHero.module.css';
import Popup from '../TypeformPopup/Popup'


const dev = process.env.REACT_APP_ENV === 'development';

const SectionHero = props => {
  const { rootClassName, className, history, isLoggedIn } = props;

  // medical, dental, law 
  const classes = classNames(rootClassName || css.root, className);
  const [text, setText] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const screenWidth =  typeof window !== "undefined" ? window.innerWidth : 999;

  useEffect(() => {
   
    setTimeout(() => {
      switch (text) {
        case "": setText("m")
        break;
        case "m": setText("me")
        break;
        case "me": setText("med")
        break;
        case "med": setText("medi")
        break;
        case "medi": setText("medic")
        break;
        case "medic": setText("medica")
        break;
        case "medica": setText("medical")
        break;
        case "medical": setText("d")
        break;
        case "d": setText("de")
        break;
        case "de": setText("den")
        break;
        case "den": setText("dent")
        break;
        case "dent": setText("denta")
        break;
        case "denta": setText("dental")
        break;
        case "dental": setText("l")
        break;
        case "l": setText("la")
        break;
        case "la": setText("law")
        break;
        case "law": setText("v")
        break;
        case "v": setText("ve")
        break;
        case "ve": setText("vet")
        break;
        case "vet": setText("P")
        break;
        case "P": setText("PA")
        break;
        case "PA": setText("m")
        break;


      }
    }
    , 500);
  }, [text]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const handleStudentSubmit = () => {

    if(isLoggedIn){
      setEmailError("You are already logged in, please log out before attempting to create a new account")
    }else{
      if( email.includes("@") && email.includes(".") && email.length >= 5){
        history.push('/signup')
        document.cookie = `studentEmail=${email}; SameSite=None; Secure`;
      }else{
        setEmailError("Please insert a valid email")
      }
    }

   
  }



  return (
    <div className={classes}>
      <div className={css.heroContent}>
        {screenWidth < 900 ? (
          <h1 className={css.heroMainTitle}>
            Find a student at your dream <br />
            <strong className={css.dynamicText}>{text}</strong> <br /> school
          </h1>
        ) : (
          <h1 className={css.heroMainTitle}>
            Find a student at your dream <br />
            <strong className={css.dynamicText}>{text}</strong> school
          </h1>
        )}

        {/* <h2 className={css.heroSubTitle}>
          <FormattedMessage id="SectionHero.subTitle" />
        </h2> */}

        {/* <Button
          name="SearchPage"
          className={css.heroButton}
        >
          <FormattedMessage id="SectionHero.browseButton" />
        </Button> */}

        {dev ? (
          <>
            <input
              placeholder="enter your email address"
              value={email}
              onChange={handleEmailChange}
              className={css.signupLink}
            />
            {emailError === '' ? null : <span className={css.emailErrorMessage}>{emailError}</span>}
            <Button
              className={css.heroButton}
              onClick={handleStudentSubmit}
              disabled={!email.includes('@') || !email.includes('.')}
            >
              <FormattedMessage id="SectionHero.browseButton" />
            </Button>
          </>
        ) : (
          <>
            <Popup />
          </>
        )}
      </div>
      <div className={css.dummyDiv}></div>
      {/* <div className={css.heroImageContainer}> */}
      {/* <img src={option3} className={css.heroImage}/> */}
      {/* </div> */}
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
